import React from "react";
import { UserStoryDto } from "../../dto/UserStoryDto";
import "./styles/CassetteTapeInlay.css";

interface CassetteTapeInlayProps {
  story: UserStoryDto;
  lang: string;
}

const CassetteTapeInlay = ({ story, lang }: CassetteTapeInlayProps) => {
  return (
    <div className="cassette-inlay">
      <div className="side-label side-a">
        A<span>{lang === "EN" ? story.titleEN : story.titleDE}</span>
      </div>

      <div className="content-area">
        <div className="side-a-content">
          <div className="content-story">
            {lang === "EN" ? story.textEN : story.textDE}
            {story.id === 99999 && (
              <img
                src="/assets/themes/tape/tape_share-story_qr.png"
                alt="Share Story"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CassetteTapeInlay;
